import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BannerImage from './BannerImage';
import NoImage from '../NoImage';
import { getImageUrl } from '../../helpers/imageUrlHelpers';

import './Banner.module.scss';

class Banner extends React.PureComponent {
  render() {
    const {
      imageUrl,
      mobileImageUrl,
      isMobile,
      ...restProps
    } = this.props;

    const imageSrc = getImageUrl(imageUrl, mobileImageUrl, isMobile);

    return (
      <div styleName={classNames('banner', { mobile: isMobile })}>
        { imageSrc
          ? <BannerImage imageSrc={imageSrc} {...restProps} />
          : <div styleName="no-image"><NoImage isMobile={isMobile} /></div>
        }
      </div>
    );
  }
}

Banner.defaultProps = {
  name: '',
};

Banner.propTypes = {
  isMobile: PropTypes.bool,
  name: PropTypes.string,
  link: PropTypes.string,
  imageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
};

export default Banner;


// WEBPACK FOOTER //
// ./src/js/widgets/Banner/Banner.js